import { FaDroplet, FaThumbsUp, FaHeadset, FaClipboardList, FaTruck } from 'react-icons/fa6';
import { FaCreditCard } from 'react-icons/fa';

const features = [
  {
    id: 1,
    icon: <FaDroplet />,
    title: 'Quality Water',
    description: 'We deliver clean, fresh drinking water from trusted sources, safe for everyday healthy use.',
  },
  {
    id: 2,
    icon: <FaThumbsUp />,
    title: 'Competitive Pricing',
    description: 'Affordable water delivery plans with transparent costs and no hidden fees for reliable service.',
  },
  {
    id: 3,
    icon: <FaHeadset />,
    title: 'Customer Support',
    description: 'Our responsive support team assists customers with orders, questions, and delivery concerns daily.',
  },
  {
    id: 4,
    icon: <FaClipboardList />,
    title: 'Easy Ordering Process',
    description: 'Quickly place your water delivery orders online or by phone in a few steps.',
  },
  {
    id: 5,
    icon: <FaTruck />,
    title: 'On-time Delivery',
    description: 'Timely delivery of sealed water bottles directly to homes and businesses without any delays.',
  },
  {
    id: 6,
    icon: <FaCreditCard />,
    title: 'Efficient Payment Options',
    description: 'We support secure and fast payment options for a smooth, hassle-free checkout every time.',
  },
];

export default features;